import { render, staticRenderFns } from "./Avantage.vue?vue&type=template&id=266a6dee&scoped=true&lang=html&"
import script from "./Avantage.vue?vue&type=script&lang=js&"
export * from "./Avantage.vue?vue&type=script&lang=js&"
import style0 from "./Avantage.vue?vue&type=style&index=0&id=266a6dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a6dee",
  null
  
)

export default component.exports